export default __webpack_public_path__ + "static/media/css.4e47c312.svg";